import { useEffect, useState, useContext } from "react";
import {  useNavigate } from "react-router-dom";
import { motion } from "framer-motion";
import BASE_URL from "../../BaseUrl";
import "../../styles/admin/AdminProfile.css";
import { GlobalContext } from "../GlobalContext";

import axios from "axios";

export default function AssistantProfile({active,setActive,setMobileActive}) {
    const navigate = useNavigate();
    const {admin, setAdmin} = useContext(GlobalContext);
    const [loaded , setLoaded] = useState(false);
    const [showUpdateform,setShowUpdateForm] = useState(false);
    const [showDeletePopup, setShowDeletePopup] = useState(false);
    const [editAdmin,setEditAdmin] = useState(null);

    const [message, setMessage] = useState("error message");
    const [showMessage, setShowMessage] = useState(false);

    const [showUpdatePassword, setShowUpdatePassword] = useState(false);
    const [newPassword,setNewPassword] = useState({
        oldPassword:"",
        newPassword:"",
        confirmPassword:"",
    })
    const openEditForm = ()=>{
        setEditAdmin({...admin});
        setShowUpdateForm(true);
    }

    const fetchData = async () => {
            let admin2 = admin;
            await axios.get(`${BASE_URL}/assistant/get-assistant-by-token`, { withCredentials: true })
                .then((response) => {
                    admin2 = response.data;
                    setLoaded(true);
                }).catch((error) => {
                    navigate("/"); // Redirect to login if admin data is not availabel
                })

            await axios.get(`${BASE_URL}/assistant/courses`, { withCredentials: true })
            .then((response) => {
                setAdmin({...admin2, courses: response.data});
                setLoaded(true);
                
            }).catch((error) => {
                console.error("Error fetching course data:", error);
                navigate("/");
                // Handle error appropriately, e.g., show a notification or redirect
            })
            await axios.get(`${BASE_URL}/assistant/teacher-info`, { withCredentials: true }).
                then(async (response)=>{
                    const updatedAdmin = {...admin, teacherName: response.data[1], teacherId: response.data[0]};
                    setAdmin(updatedAdmin);
                }).catch((err)=>{
                    console.log(err);
                })
        
    }

    const deleteAdmin = () => {
        axios.delete(`${BASE_URL}/assistant/delete-account`, { withCredentials: true })
            .then((response) => {
                navigate("/");
            }).catch((error) => {
                console.log(error);
            })
        }

    const updateAdmin = ()=>{
        axios.put(`${BASE_URL}/assistant/update-assistant-info`,editAdmin,{withCredentials: true})
        .then((response)=>{
            setShowUpdateForm(false);
            setAdmin({...editAdmin});
        }).catch((error)=>{
            console.log(error);
            setShowUpdateForm(false);
        })
    }

    async function updatePassword(){
        if(newPassword.oldPassword === "" || newPassword.newPassword === "" || newPassword.confirmPassword === "" ){
            setMessage("يجب ملئ جميع الحقول");
            setShowMessage(true);
            return;
        }
        if(newPassword.newPassword !== newPassword.confirmPassword){
            setMessage("تأكيد كلمة المرور غير متطابق");
            setShowMessage(true);
            return;
        }
        const newpassword = newPassword.newPassword;
        const oldPassword = newPassword.oldPassword;
        try{
            const response = await axios.put(`${BASE_URL}/assistant/update-password`,{oldPassword,newpassword},{withCredentials:true});
            setMessage(response.data);
            setShowMessage(true);
        }catch(error){
            if(error.response.status === 403){
                setMessage(error.response.data);
                setShowMessage(true);
            }
            else{
                console.log(error);
            }
        }

    }

    useEffect(() => {
        fetchData();
        setActive("الملف الشخصي")
        setMobileActive("profile mobile");
        console.log(admin);
    },[])
    return (
        loaded&&<div className="admin-profile-nav-container">
            <div className="admin-profile-container">
                <motion.div
                    initial={{opacity: 0 , x : -100}}
                    animate={{opacity: 1 , x : 0}}
                    transition={{delay: 0.3}}
                    exit={{opacity: 0 , x : -100}}
                    className="advanced-links-motion"
                >
                <div className="advanced-links">
                    <label onClick={openEditForm}> 🔄تحديث البيانات</label>
                    <br />
                    <br />
                    <label onClick={()=>setShowUpdatePassword(true)}>🔒تغير كلمة المرور</label>
                    <br />
                    <br />
                    <label onClick={()=>{window.open("https://wa.me/201030452252", "_blank")}}>👨🏻‍💼تواصل مع المالك</label>
                    <br />
                    <br />
                    <label className="delete-account-button" onClick={()=>{setShowDeletePopup(true)}}>🗑️حذف الحساب</label>
                </div>
                </motion.div>
                <motion.div
                    initial={{opacity: 0 , x : 100}}
                    animate={{opacity: 1 , x : 0}}
                    transition={{delay: 0.3}}
                    exit={{opacity: 0 , x : 100}}
                    className="admin-profile-motion"
                >
                    <div className="admin-profile assistant-profile">
                        <h2>الملف الشخصي</h2>
                        <label>الاسم</label>
                        <input type="text" value={admin.name} readOnly />
                        <label>البريد الإلكتروني</label>
                        <input type="text" value={admin.email} readOnly/>
                        <label>إجمالي الحساب</label>
                        <input type="text" value={admin.totalFunds} readOnly/>
                        <label>المستحق</label>
                        <input type="text" value={admin.currentFunds} readOnly/>
                    </div>
                </motion.div>
            </div>

            {showDeletePopup&& (
                <div className="overlay">
                <div className="delete-admin-confirmation">
                    <h3>هل انت متأكد أنك تريد حذف حسابك</h3>
                    <div style={{display:"flex",
                        justifyContent:"space-between",
                        paddingRight:"20%",
                        paddingLeft:"20%"
                    }}>
                        <button className="yes" onClick={() => deleteAdmin()}>حذف</button>
                        <button onClick={() => setShowDeletePopup(false)}>لا</button>
                    </div>
                </div>
                </div>

            )}

            { showUpdateform && (
                <div className="overlay">
                            <div className="edit-admin-form admin-edit-form">
                                <h3>تعديل البيانات</h3>
                                <label>الاسم</label>
                                <input
                                    dir="rtl"
                                    lang="ar"
                                    type="text"
                                    value={editAdmin.name}
                                    onChange={(e) => setEditAdmin({ ...editAdmin, name: e.target.value })}/>

                                <div className="edit-admin-buttons-div">     
                                    <button className="update-admin-button" onClick={updateAdmin}>تحديث</button>
                                    <button id="cancel-update-admin-info" onClick={() => setShowUpdateForm(false)}>إلغاء</button>
                                </div>
                            </div>
                            </div>
                        )}


            { showUpdatePassword && (
                <div className="overlay">
                            <div className="edit-admin-form admin-edit-form">
                                <h3>تحديث كلمة المرور</h3>
                                <label>كلمة المرور القديمة</label>
                                <input
                                    type="password"
                                    value={newPassword.oldPassword}
                                    onChange={(e) => setNewPassword({ ...newPassword, oldPassword: e.target.value })}/>
                                <label>كلمة المرور الجديدة</label>
                                <input
                                    type="password"
                                    value={newPassword.newPassword}
                                    onChange={(e) => setNewPassword({ ...newPassword, newPassword: e.target.value })}/>
                                
                                <label>تأكيد كلمة المرور</label>
                                <input
                                    type="password"
                                    value={newPassword.confirmPassword}
                                    onChange={(e) => setNewPassword({ ...newPassword, confirmPassword: e.target.value })}/>

                                <div className="edit-admin-buttons-div">     
                                    <button className="update-admin-button" onClick={updatePassword}>تحديث</button>
                                    <button id="cancel-update-admin-info" onClick={() => {setShowUpdatePassword(false);setNewPassword({oldPassword:"",newPassword:"",confirmPassword:""})}}>إلغاء</button>
                                </div>
                            </div>
                            </div>
                        )}

            { showMessage && (
                <div className="overlay">
                <div className="home-owner-message">
                    <p>{message}</p>
                    <button onClick={() => {setShowMessage(false);setMessage("")}}>اغلاق</button>
                </div>
                </div>
            )}
        </div>
    )

}